<template>
    <div class="bigDiv">
        <el-row class="footer" style="margin: 0 auto" :gutter="20">
            <el-col
                    class="col"
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="6"
                    :xl="6"
                    v-for="(item, index) in hxFooterList"
                    :key="index"
            >
                <div class="grid-content">
                    <div style="color: #ffffff; font-weight: bold; font-size: 14px">
                        {{ item.title }}
                    </div>
                    <p
                            class="ql-editor"
                            v-html="item.content"
                            style="font-size: 14px;padding:0px"
                    ></p>
                </div>
            </el-col>
        </el-row>

        <!-- <div style="margin: 0;width: 100%;height: 1px;background: white;margin: 10px 0;"></div> -->

        <div
                class="footer pt30 "
                style="
        display: flex;
        justify-content: center;
        color: #fff;
        font-size: 12px;
        margin: 0 auto;
      "
        >
            <div class="ql-editor" v-html="websiteData.filings"></div>
        </div>
    </div>
</template>

<script>
    import { listEnableHxFooter } from "@/api/footer";

    export default {
        name: "footer-index",
        props: {
            websiteData: Object,
        },
        data() {
            return {
                // 底部数据
                hxFooterList: [],
            };
        },
        created() {
            listEnableHxFooter().then((response) => {
                this.hxFooterList = response.rows;
            });
        },
    };
</script>

<style scoped>
    .bold {
        font-weight: bold;
    }

    @media screen and (min-width: 1200px) {
        .bigDiv {
            padding-top: 50px;
        }
        .footer {
            width: 70%;
            /* margin:50px 0px */
        }
        .pt30{
            padding-top:30px;
        }
    }

    @media screen and (max-width: 1200px) {
        .bigDiv {
            padding-top: 50px;
        }
        .footer {
            width: 80%;
        }
        .pt{
            padding-top:30px;
        }
        .pt30{
            padding-top:20px;
        }
    }

    @media screen and (max-width: 870px) {
        .bigDiv {
            padding-top: 45px;
        }
        .footer {
            width: 80%;
        }
        .pt30{
            padding-top:30px;
        }
    }

    @media screen and (max-width: 570px) {
        .col {
            margin-top: 15px;
        }

        .footer {
            width: 100%;
            padding: 0 10px;
        }
        .bigDiv {
            padding-top: 10px;
        }
        .pt30{
            margin-top:10px!important;
            padding: 0px 0px!important;
        }

    }
</style>
